import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'durationDisplay' })
export class DurationDisplayPipe implements PipeTransform {
  transform(duration: number | string, unit?: string): string {
    if (!duration) return '';
    const u = unit
      ? unit.charAt(0).toUpperCase() + unit.slice(1).toLowerCase()
      : 'Mins';
    return `${duration} ${u}`;
  }
}
